/*!
 * x509.js - X509 for javascript
 * Copyright (c) 2018, Christopher Jeffrey (MIT License).
 * https://github.com/bcoin-org/bcrypto
 *
 * Parts of this software are based on indutny/asn1.js:
 *   Copyright Fedor Indutny, 2013.
 *   https://github.com/indutny/asn1.js
 *
 * Resources:
 *   https://www.ietf.org/rfc/rfc2560.txt
 *   https://www.ietf.org/rfc/rfc5280.txt
 *   https://github.com/indutny/asn1.js/blob/master/rfc/2560/index.js
 *   https://github.com/indutny/asn1.js/blob/master/rfc/5280/index.js
 *   https://github.com/indutny/asn1.js/blob/master/lib/asn1/base/node.js
 *   https://github.com/indutny/asn1.js/blob/master/lib/asn1/encoders/der.js
 *   https://github.com/indutny/asn1.js/blob/master/lib/asn1/decoders/der.js
 */
'use strict';

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var assert = require('bsert');

var asn1 = require('./asn1');

var pem = require('./pem');

var types = asn1.types;
/**
 * Certificate
 */
// Certificate  ::=  SEQUENCE  {
//      tbsCertificate       TBSCertificate,
//      signatureAlgorithm   AlgorithmIdentifier,
//      signature            BIT STRING  }

var Certificate = /*#__PURE__*/function (_asn1$Sequence) {
  _inherits(Certificate, _asn1$Sequence);

  var _super = _createSuper(Certificate);

  function Certificate() {
    var _this;

    _classCallCheck(this, Certificate);

    _this = _super.call(this);
    _this.tbsCertificate = new TBSCertificate();
    _this.signatureAlgorithm = new AlgorithmIdentifier();
    _this.signature = new asn1.BitString();
    return _this;
  }

  _createClass(Certificate, [{
    key: "getBodySize",
    value: function getBodySize() {
      var size = 0;
      size += this.tbsCertificate.getSize();
      size += this.signatureAlgorithm.getSize();
      size += this.signature.getSize();
      return size;
    }
  }, {
    key: "writeBody",
    value: function writeBody(bw) {
      this.tbsCertificate.write(bw);
      this.signatureAlgorithm.write(bw);
      this.signature.write(bw);
      return bw;
    }
  }, {
    key: "readBody",
    value: function readBody(br) {
      this.tbsCertificate.read(br);
      this.signatureAlgorithm.read(br);
      this.signature.read(br);
      return this;
    }
  }, {
    key: "clean",
    value: function clean() {
      return this.tbsCertificate.clean() && this.signatureAlgorithm.clean() && this.signature.clean();
    }
  }, {
    key: "toPEM",
    value: function toPEM() {
      return pem.toPEM(this.encode(), 'CERTIFICATE');
    }
  }, {
    key: "fromPEM",
    value: function fromPEM(str) {
      var data = pem.fromPEM(str, 'CERTIFICATE');
      return this.decode(data);
    }
  }, {
    key: "format",
    value: function format() {
      return {
        type: this.constructor.name,
        tbsCertificate: this.tbsCertificate,
        signatureAlgorithm: this.signatureAlgorithm,
        signature: this.signature
      };
    }
  }, {
    key: "isRaw",
    get: function get() {
      return true;
    }
  }]);

  return Certificate;
}(asn1.Sequence);
/**
 * TBSCertificate
 */
// TBSCertificate  ::=  SEQUENCE  {
//      version         [0]  Version DEFAULT v1,
//      serialNumber         CertificateSerialNumber,
//      signature            AlgorithmIdentifier,
//      issuer               Name,
//      validity             Validity,
//      subject              Name,
//      subjectPublicKeyInfo SubjectPublicKeyInfo,
//      issuerUniqueID  [1]  IMPLICIT UniqueIdentifier OPTIONAL,
//      subjectUniqueID [2]  IMPLICIT UniqueIdentifier OPTIONAL,
//      extensions      [3]  Extensions OPTIONAL }
//
// Version  ::=  INTEGER  {  v1(0), v2(1), v3(2)  }


var TBSCertificate = /*#__PURE__*/function (_asn1$Sequence2) {
  _inherits(TBSCertificate, _asn1$Sequence2);

  var _super2 = _createSuper(TBSCertificate);

  function TBSCertificate() {
    var _this2;

    _classCallCheck(this, TBSCertificate);

    _this2 = _super2.call(this);
    _this2.version = new asn1.Unsigned().explicit(0).optional();
    _this2.serialNumber = new asn1.Integer();
    _this2.signature = new AlgorithmIdentifier();
    _this2.issuer = new RDNSequence();
    _this2.validity = new Validity();
    _this2.subject = new RDNSequence();
    _this2.subjectPublicKeyInfo = new SubjectPublicKeyInfo();
    _this2.issuerUniqueID = new asn1.BitString().implicit(1).optional();
    _this2.subjectUniqueID = new asn1.BitString().implicit(2).optional();
    _this2.extensions = new Extensions().explicit(3).optional();
    return _this2;
  }

  _createClass(TBSCertificate, [{
    key: "getBodySize",
    value: function getBodySize() {
      var size = 0;
      size += this.version.getSize();
      size += this.serialNumber.getSize();
      size += this.signature.getSize();
      size += this.issuer.getSize();
      size += this.validity.getSize();
      size += this.subject.getSize();
      size += this.subjectPublicKeyInfo.getSize();
      size += this.issuerUniqueID.getSize();
      size += this.subjectUniqueID.getSize();
      size += this.extensions.getSize();
      return size;
    }
  }, {
    key: "writeBody",
    value: function writeBody(bw) {
      this.version.write(bw);
      this.serialNumber.write(bw);
      this.signature.write(bw);
      this.issuer.write(bw);
      this.validity.write(bw);
      this.subject.write(bw);
      this.subjectPublicKeyInfo.write(bw);
      this.issuerUniqueID.write(bw);
      this.subjectUniqueID.write(bw);
      this.extensions.write(bw);
      return bw;
    }
  }, {
    key: "readBody",
    value: function readBody(br) {
      this.version.read(br);
      this.serialNumber.read(br);
      this.signature.read(br);
      this.issuer.read(br);
      this.validity.read(br);
      this.subject.read(br);
      this.subjectPublicKeyInfo.read(br);
      this.issuerUniqueID.read(br);
      this.subjectUniqueID.read(br);
      this.extensions.read(br);
      return this;
    }
  }, {
    key: "clean",
    value: function clean() {
      return this.version.clean() && this.serialNumber.clean() && this.signature.clean() && this.issuer.clean() && this.validity.clean() && this.subject.clean() && this.subjectPublicKeyInfo.clean() && this.issuerUniqueID.clean() && this.subjectUniqueID.clean() && this.extensions.clean();
    }
  }, {
    key: "toPEM",
    value: function toPEM() {
      return pem.toPEM(this.encode(), 'TBS CERTIFICATE');
    }
  }, {
    key: "fromPEM",
    value: function fromPEM(str) {
      var data = pem.fromPEM(str, 'TBS CERTIFICATE');
      return this.decode(data);
    }
  }, {
    key: "format",
    value: function format() {
      return {
        type: this.constructor.name,
        version: this.version,
        serialNumber: this.serialNumber,
        signature: this.signature,
        issuer: this.issuer,
        validity: this.validity,
        subject: this.subject,
        subjectPublicKeyInfo: this.subjectPublicKeyInfo,
        issuerUniqueID: this.issuerUniqueID,
        subjectUniqueID: this.subjectUniqueID,
        extensions: this.extensions
      };
    }
  }, {
    key: "isRaw",
    get: function get() {
      return true;
    }
  }]);

  return TBSCertificate;
}(asn1.Sequence);
/**
 * AlgorithmIdentifier
 */
// AlgorithmIdentifier  ::=  SEQUENCE  {
//      algorithm               OBJECT IDENTIFIER,
//      parameters              ANY DEFINED BY algorithm OPTIONAL  }


var AlgorithmIdentifier = /*#__PURE__*/function (_asn1$Sequence3) {
  _inherits(AlgorithmIdentifier, _asn1$Sequence3);

  var _super3 = _createSuper(AlgorithmIdentifier);

  function AlgorithmIdentifier(algorithm, parameters) {
    var _this3;

    _classCallCheck(this, AlgorithmIdentifier);

    _this3 = _super3.call(this);
    _this3.algorithm = new asn1.OID(algorithm);
    _this3.parameters = new asn1.Any(parameters).optional();
    return _this3;
  }

  _createClass(AlgorithmIdentifier, [{
    key: "getBodySize",
    value: function getBodySize() {
      var size = 0;
      size += this.algorithm.getSize();
      size += this.parameters.getSize();
      return size;
    }
  }, {
    key: "writeBody",
    value: function writeBody(bw) {
      this.algorithm.write(bw);
      this.parameters.write(bw);
      return bw;
    }
  }, {
    key: "readBody",
    value: function readBody(br) {
      this.algorithm.read(br);
      this.parameters.read(br);
      return this;
    }
  }, {
    key: "clean",
    value: function clean() {
      return this.algorithm.clean() && this.parameters.clean();
    }
  }, {
    key: "format",
    value: function format() {
      return {
        type: this.constructor.name,
        algorithm: this.algorithm,
        parameters: this.parameters
      };
    }
  }]);

  return AlgorithmIdentifier;
}(asn1.Sequence);
/**
 * RDNSequence
 */
// Name ::= CHOICE { -- only one possibility for now --
//      rdnSequence  RDNSequence }
//
// RDNSequence ::= SEQUENCE OF RelativeDistinguishedName


var RDNSequence = /*#__PURE__*/function (_asn1$Sequence4) {
  _inherits(RDNSequence, _asn1$Sequence4);

  var _super4 = _createSuper(RDNSequence);

  function RDNSequence() {
    var _this4;

    _classCallCheck(this, RDNSequence);

    _this4 = _super4.call(this);
    _this4.names = [];
    return _this4;
  }

  _createClass(RDNSequence, [{
    key: "getBodySize",
    value: function getBodySize() {
      var size = 0;

      var _iterator = _createForOfIteratorHelper(this.names),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var rdn = _step.value;
          size += rdn.getSize();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return size;
    }
  }, {
    key: "writeBody",
    value: function writeBody(bw) {
      var _iterator2 = _createForOfIteratorHelper(this.names),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var rdn = _step2.value;
          rdn.write(bw);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return bw;
    }
  }, {
    key: "readBody",
    value: function readBody(br) {
      while (br.left()) {
        var rdn = RDN.read(br);
        this.names.push(rdn);
      }

      return this;
    }
  }, {
    key: "clean",
    value: function clean() {
      return this.names.length === 0;
    }
  }, {
    key: "format",
    value: function format() {
      return {
        type: this.constructor.name,
        names: this.names
      };
    }
  }]);

  return RDNSequence;
}(asn1.Sequence);
/**
 * RDN
 */
// RelativeDistinguishedName ::=
//      SET SIZE (1..MAX) OF AttributeTypeAndValue
//


var RDN = /*#__PURE__*/function (_asn1$Set) {
  _inherits(RDN, _asn1$Set);

  var _super5 = _createSuper(RDN);

  function RDN(id, value) {
    var _this5;

    _classCallCheck(this, RDN);

    _this5 = _super5.call(this);
    _this5.attributes = [new Attribute(id, value)];
    return _this5;
  }

  _createClass(RDN, [{
    key: "getBodySize",
    value: function getBodySize() {
      var size = 0;
      assert(this.attributes.length >= 1);

      var _iterator3 = _createForOfIteratorHelper(this.attributes),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var attr = _step3.value;
          size += attr.getSize();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return size;
    }
  }, {
    key: "writeBody",
    value: function writeBody(bw) {
      assert(this.attributes.length >= 1);

      var _iterator4 = _createForOfIteratorHelper(this.attributes),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var attr = _step4.value;
          attr.write(bw);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return bw;
    }
  }, {
    key: "readBody",
    value: function readBody(br) {
      this.attributes[0].read(br);

      while (br.left()) {
        var attr = Attribute.read(br);
        this.attributes.push(attr);
      }

      return this;
    }
  }, {
    key: "clean",
    value: function clean() {
      return this.attributes.length === 1 && this.attributes[0].clean();
    }
  }, {
    key: "format",
    value: function format() {
      return {
        type: this.constructor.name,
        attributes: this.attributes
      };
    }
  }]);

  return RDN;
}(asn1.Set);
/**
 * Attribute
 */
// AttributeTypeAndValue ::= SEQUENCE {
//      type     AttributeType,
//      value    AttributeValue }
//
// AttributeType ::= OBJECT IDENTIFIER
//
// AttributeValue ::= ANY -- DEFINED BY AttributeType


var Attribute = /*#__PURE__*/function (_asn1$Sequence5) {
  _inherits(Attribute, _asn1$Sequence5);

  var _super6 = _createSuper(Attribute);

  function Attribute(id, value) {
    var _this6;

    _classCallCheck(this, Attribute);

    _this6 = _super6.call(this);
    _this6.id = new asn1.OID(id);
    _this6.value = new asn1.Any(value);
    return _this6;
  }

  _createClass(Attribute, [{
    key: "getBodySize",
    value: function getBodySize() {
      var size = 0;
      size += this.id.getSize();
      size += this.value.getSize();
      return size;
    }
  }, {
    key: "writeBody",
    value: function writeBody(bw) {
      this.id.write(bw);
      this.value.write(bw);
      return bw;
    }
  }, {
    key: "readBody",
    value: function readBody(br) {
      this.id.read(br);
      this.value.read(br);
      return this;
    }
  }, {
    key: "clean",
    value: function clean() {
      return this.id.clean() && this.value.clean();
    }
  }, {
    key: "format",
    value: function format() {
      return {
        type: this.constructor.name,
        id: this.id,
        value: this.value
      };
    }
  }]);

  return Attribute;
}(asn1.Sequence);
/**
 * Validity
 */
// Validity ::= SEQUENCE {
//      notBefore      Time,
//      notAfter       Time  }


var Validity = /*#__PURE__*/function (_asn1$Sequence6) {
  _inherits(Validity, _asn1$Sequence6);

  var _super7 = _createSuper(Validity);

  function Validity() {
    var _this7;

    _classCallCheck(this, Validity);

    _this7 = _super7.call(this);
    _this7.notBefore = new Time();
    _this7.notAfter = new Time();
    return _this7;
  }

  _createClass(Validity, [{
    key: "getBodySize",
    value: function getBodySize() {
      var size = 0;
      size += this.notBefore.getSize();
      size += this.notAfter.getSize();
      return size;
    }
  }, {
    key: "writeBody",
    value: function writeBody(bw) {
      this.notBefore.write(bw);
      this.notAfter.write(bw);
      return bw;
    }
  }, {
    key: "readBody",
    value: function readBody(br) {
      this.notBefore.read(br);
      this.notAfter.read(br);
      return this;
    }
  }, {
    key: "clean",
    value: function clean() {
      return this.notBefore.clean() && this.notAfter.clean();
    }
  }, {
    key: "format",
    value: function format() {
      return {
        type: this.constructor.name,
        notBefore: this.notBefore,
        notAfter: this.notAfter
      };
    }
  }]);

  return Validity;
}(asn1.Sequence);
/**
 * Time
 */
// Time ::= CHOICE {
//      utcTime        UTCTime,
//      generalTime    GeneralizedTime }


var Time = /*#__PURE__*/function (_asn1$Choice) {
  _inherits(Time, _asn1$Choice);

  var _super8 = _createSuper(Time);

  function Time(options) {
    _classCallCheck(this, Time);

    return _super8.call(this, new asn1.UTCTime(), options);
  }

  _createClass(Time, [{
    key: "choices",
    value: function choices() {
      return [types.UTCTIME, types.GENTIME];
    }
  }]);

  return Time;
}(asn1.Choice); // SubjectPublicKeyInfo  ::=  SEQUENCE  {
//      algorithm            AlgorithmIdentifier,
//      subjectPublicKey     BIT STRING  }


var SubjectPublicKeyInfo = /*#__PURE__*/function (_asn1$Sequence7) {
  _inherits(SubjectPublicKeyInfo, _asn1$Sequence7);

  var _super9 = _createSuper(SubjectPublicKeyInfo);

  function SubjectPublicKeyInfo(algorithm, parameters, publicKey) {
    var _this8;

    _classCallCheck(this, SubjectPublicKeyInfo);

    _this8 = _super9.call(this);
    _this8.algorithm = new AlgorithmIdentifier(algorithm, parameters);
    _this8.publicKey = new asn1.BitString(publicKey);
    return _this8;
  }

  _createClass(SubjectPublicKeyInfo, [{
    key: "getBodySize",
    value: function getBodySize() {
      var size = 0;
      size += this.algorithm.getSize();
      size += this.publicKey.getSize();
      return size;
    }
  }, {
    key: "writeBody",
    value: function writeBody(bw) {
      this.algorithm.write(bw);
      this.publicKey.write(bw);
      return bw;
    }
  }, {
    key: "readBody",
    value: function readBody(br) {
      this.algorithm.read(br);
      this.publicKey.read(br);
      return this;
    }
  }, {
    key: "clean",
    value: function clean() {
      return this.algorithm.clean() && this.publicKey.clean();
    }
  }, {
    key: "toPEM",
    value: function toPEM() {
      return pem.toPEM(this.encode(), 'PUBLIC KEY');
    }
  }, {
    key: "fromPEM",
    value: function fromPEM(str) {
      var data = pem.fromPEM(str, 'PUBLIC KEY');
      return this.decode(data);
    }
  }, {
    key: "format",
    value: function format() {
      return {
        type: this.constructor.name,
        algorithm: this.algorithm,
        publicKey: this.publicKey
      };
    }
  }, {
    key: "isRaw",
    get: function get() {
      return true;
    }
  }]);

  return SubjectPublicKeyInfo;
}(asn1.Sequence);
/**
 * Extensions
 */


var Extensions = /*#__PURE__*/function (_asn1$Sequence8) {
  _inherits(Extensions, _asn1$Sequence8);

  var _super10 = _createSuper(Extensions);

  function Extensions() {
    var _this9;

    _classCallCheck(this, Extensions);

    _this9 = _super10.call(this);
    _this9.extensions = [];
    return _this9;
  }

  _createClass(Extensions, [{
    key: "getBodySize",
    value: function getBodySize() {
      var size = 0;

      var _iterator5 = _createForOfIteratorHelper(this.extensions),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var ext = _step5.value;
          size += ext.getSize();
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      return size;
    }
  }, {
    key: "writeBody",
    value: function writeBody(bw) {
      var _iterator6 = _createForOfIteratorHelper(this.extensions),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var ext = _step6.value;
          ext.write(bw);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      return bw;
    }
  }, {
    key: "readBody",
    value: function readBody(br) {
      var _iterator7 = _createForOfIteratorHelper(this.extensions),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var ext = _step7.value;
          ext.read(br);
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      return this;
    }
  }, {
    key: "clean",
    value: function clean() {
      return this.extensions.length === 0;
    }
  }, {
    key: "format",
    value: function format() {
      return {
        type: this.constructor.name,
        extensions: this.extensions
      };
    }
  }]);

  return Extensions;
}(asn1.Sequence);
/**
 * Extension
 */
// Extension  ::=  SEQUENCE  {
//      extnID      OBJECT IDENTIFIER,
//      critical    BOOLEAN DEFAULT FALSE,
//      extnValue   OCTET STRING }


var Extension = /*#__PURE__*/function (_asn1$Sequence9) {
  _inherits(Extension, _asn1$Sequence9);

  var _super11 = _createSuper(Extension);

  function Extension() {
    var _this10;

    _classCallCheck(this, Extension);

    _this10 = _super11.call(this);
    _this10.extnID = new asn1.OID();
    _this10.critical = new asn1.Bool().optional();
    _this10.extnValue = new asn1.OctString();
    return _this10;
  }

  _createClass(Extension, [{
    key: "getBodySize",
    value: function getBodySize() {
      var size = 0;
      size += this.extnID.getSize();
      size += this.critical.getSize();
      size += this.extnValue.getSize();
      return size;
    }
  }, {
    key: "writeBody",
    value: function writeBody(bw) {
      this.extnID.write(bw);
      this.critical.write(bw);
      this.extnValue.write(bw);
      return bw;
    }
  }, {
    key: "readBody",
    value: function readBody(br) {
      this.extnID.read(br);
      this.critical.read(br);
      this.extnValue.read(br);
      return this;
    }
  }, {
    key: "clean",
    value: function clean() {
      return this.extnID.clean() && this.critical.clean() && this.extnValue.clean();
    }
  }, {
    key: "format",
    value: function format() {
      return {
        type: this.constructor.name,
        extnID: this.extnID,
        critical: this.critical,
        extnValue: this.extnValue
      };
    }
  }]);

  return Extension;
}(asn1.Sequence);
/**
 * DigestInfo
 */
// See: https://www.ietf.org/rfc/rfc3447.txt
// Section 9.2
//
// DigestInfo ::= SEQUENCE {
//   digestAlgorithm AlgorithmIdentifier,
//   digest OCTET STRING
// }


var DigestInfo = /*#__PURE__*/function (_asn1$Sequence10) {
  _inherits(DigestInfo, _asn1$Sequence10);

  var _super12 = _createSuper(DigestInfo);

  function DigestInfo(algorithm, digest) {
    var _this11;

    _classCallCheck(this, DigestInfo);

    _this11 = _super12.call(this);
    _this11.algorithm = new AlgorithmIdentifier(algorithm);

    _this11.algorithm.parameters.optional(false);

    _this11.digest = new asn1.OctString(digest);
    return _this11;
  }

  _createClass(DigestInfo, [{
    key: "getBodySize",
    value: function getBodySize() {
      var size = 0;
      size += this.algorithm.getSize();
      size += this.digest.getSize();
      return size;
    }
  }, {
    key: "writeBody",
    value: function writeBody(bw) {
      this.algorithm.write(bw);
      this.digest.write(bw);
      return bw;
    }
  }, {
    key: "readBody",
    value: function readBody(br) {
      this.algorithm.read(br);
      this.digest.read(br);
      return this;
    }
  }, {
    key: "clean",
    value: function clean() {
      return this.algorithm.clean() && this.digest.clean();
    }
  }, {
    key: "format",
    value: function format() {
      return {
        type: this.constructor.name,
        algorithm: this.algorithm,
        digest: this.digest
      };
    }
  }]);

  return DigestInfo;
}(asn1.Sequence);
/*
 * Expose
 */


exports.Certificate = Certificate;
exports.TBSCertificate = TBSCertificate;
exports.AlgorithmIdentifier = AlgorithmIdentifier;
exports.RDNSequence = RDNSequence;
exports.RDN = RDN;
exports.Attribute = Attribute;
exports.Validity = Validity;
exports.Time = Time;
exports.SubjectPublicKeyInfo = SubjectPublicKeyInfo;
exports.Extensions = Extensions;
exports.Extension = Extension;
exports.DigestInfo = DigestInfo;